import { render, staticRenderFns } from "./BulkPersonalizationSplit.vue?vue&type=template&id=ecbc36da&scoped=true"
import script from "./BulkPersonalizationSplit.vue?vue&type=script&lang=js"
export * from "./BulkPersonalizationSplit.vue?vue&type=script&lang=js"
import style0 from "./BulkPersonalizationSplit.vue?vue&type=style&index=0&id=ecbc36da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbc36da",
  null
  
)

export default component.exports